export const guardarDataLocal = ({clave, data}) => {


    let dataString = JSON.stringify(data)

    window.localStorage.setItem(clave, dataString)


}